import { XPropertyAPI } from 'utils/httpAPI'
export const initObj = {
  badWords: '',
}

XPropertyAPI.badWords().then((res) => {
  initObj['badWords'] = `${res.data?.properties?.chat_bad_words_regex || ''}`
})
